
function HamburgerMenuButton({ onClick }) {
  return (
    <button className="navbar-icon" aria-label="Menu" onClick={onClick}>
      <i className="bi bi-list" style={{ fontSize: "2rem" }}></i>
    </button>
  );
}
export default HamburgerMenuButton;